<script setup lang="ts">
import type { TReview } from "./shared";

defineProps<{
    review: TReview;
}>();
</script>

<template>
    <div
        class="w-full p-6 border bg-white border-secondary-border flex flex-col gap-4 rounded-12"
    >
        <div class="w-full flex justify-center gap-4">
            <div class="size-16 shrink-0 overflow-hidden">
                <img
                    :src="review.image"
                    :alt="review.name"
                    class="w-full h-full object-cover"
                />
            </div>
            <div class="w-full flex flex-col">
                <h3 class="font-mulish text-cloud-burst font-medium text-16 leading-6">
                    {{ review.organization }}
                </h3>
                <p class="font-mulish text-14 leading-5 text-sonic-silver">
                    {{ review.name }}
                </p>
                <p class="font-mulish text-14 leading-5 text-sonic-silver">
                    {{ review.role }}
                </p>
            </div>
        </div>
        <p class="w-full font-mulish text-16 leading-6 text-sonic-silver font-normal">
            {{ review.review }}
        </p>
    </div>
</template>
